// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "servicecenter" + "." + "b56e9cfff9ed5881" + ".css";
};